<template>
  <div>
    <p
      v-if="isExpanded || !short"
      :class="[textClass, isExpanded || 'clamped']"
      v-html="html"
    />
    <p v-else :class="textClass">{{ short }}</p>
    <div v-if="isExpandable" class="mx-8 mt-4 flex justify-start">
      <section-button
        :label="isExpanded ? 'Read less' : 'Read more'"
        @onClick="isExpanded = !isExpanded"
      />
    </div>
  </div>
</template>

<script>
import SectionButton from "./containers/SectionButton.vue";

export default {
  components: {
    SectionButton,
  },

  props: {
    short: {
      type: String,
    },

    html: {
      type: String,
    },
  },

  data() {
    return {
      isExpanded: false,
      textClass:
        "px-8 m-0 font-helvetica text-16 line-24 spacing-1 text-mid-dark-grey",
    };
  },

  computed: {
    isExpandable() {
      return !!this.html && this.html !== this.short;
    },
  },
};
</script>
